module.exports = __webpack_public_path__ + "png/cards1.png?01fcb405ba4288bb9abb39713f18bff3";